enum View {
  Haves,
  Dashboard,
  GuiidePlus,
  You,
  Design,
  Test,
  Requirements,
  Life,
  Home,
  LowCostProviders,
  Finish,
  NoView,
  IFAPanel,
  Secure,
  Integration,
  FAQ,
  Media,
  Login,
  UserHome,
  ForgotPassword,
  ResetForgottenPassword,
  ConfirmEmail,
  HowToCompleteDesign
}

export default View;
